import React, { Component } from "react";

import Earnings from "./Earnings";
import Navbar from "./Navbar";
import Packages from "./Packages";
import Profile from "./Profile";
import Transactions from "./Transactions";

export class Dashboard extends Component {
  render() {
    return (
      <div class="m-3 pt-3">
        <div class="row mx-lg-n5">
          <div class="col-9 px-lg-5">
            <div class="mt-3">
              <Navbar />
            </div>
            <div class="mt-5">
              <Packages />
            </div>
            <div class="mt-5">
              <Transactions />
            </div>
          </div>

          <div class="col-3 px-lg-5">
            <Profile />
            <Earnings />
          </div>
        </div>
      </div>
    );
  }
}

export default Dashboard;
